import * as React from 'react';
import { css } from 'aphrodite';
import { SvgIcon } from '../../../components/svgs/icons/SvgIcon';
import { AssigneeIcon } from '../../svgs/icons/AssigneeIcon';
import { styleSheet } from './styles';

interface IIconProps {
	fillColor?: string;
}

export const BirthdayIcon: React.FC<IIconProps> = ({ fillColor = '#000' }) => (
	<SvgIcon width='18' height='23' fill='none'>
		<path
			fill={fillColor}
			d='M15.3 20.308H2.7c-.496 0-.9-.38-.9-.846v-2.164a3.727 3.727 0 0 0 1.8.471c1.074 0 2.04-.444 2.7-1.147A3.695 3.695 0 0 0 9 17.769c1.074 0 2.04-.444 2.7-1.147a3.695 3.695 0 0 0 2.7 1.147c.659 0 1.268-.18 1.8-.471v2.164c0 .466-.404.846-.9.846Zm.9-5.923c0 .933-.807 1.692-1.8 1.692s-1.8-.76-1.8-1.692c0-.467-.403-.846-.9-.846s-.9.379-.9.846c0 .933-.807 1.692-1.8 1.692s-1.8-.76-1.8-1.692c0-.467-.403-.846-.9-.846s-.9.379-.9.846c0 .933-.807 1.692-1.8 1.692s-1.8-.76-1.8-1.692v-1.693h14.4v1.693ZM17.1 11H.9c-.497 0-.9.38-.9.846v7.616C0 20.861 1.211 22 2.7 22h12.6c1.489 0 2.7-1.139 2.7-2.538v-7.616c0-.467-.403-.846-.9-.846ZM15.5 3.552c.48.875.827 1.66.833 1.936 0 .498-.374.903-.833.903-.46 0-.833-.405-.833-.902.006-.275.353-1.061.833-1.937Zm-.833 4.477V10h1.666V8.03C17.301 7.655 18 6.662 18 5.487c0-1.153-1.27-3.266-1.814-4.122-.311-.488-1.061-.488-1.372 0C14.268 2.222 13 4.335 13 5.488c0 1.175.698 2.168 1.667 2.541ZM2.5 3.552c.48.875.827 1.66.833 1.936 0 .498-.374.903-.833.903-.46 0-.833-.405-.833-.902.006-.275.353-1.061.833-1.937Zm-.833 4.477V10h1.666V8.03C4.301 7.655 5 6.662 5 5.487c0-1.153-1.27-3.266-1.814-4.122-.311-.488-1.061-.488-1.372 0C1.268 2.222 0 4.335 0 5.488 0 6.663.698 7.656 1.667 8.03ZM8.5 3.552c.48.875.827 1.66.833 1.936 0 .498-.374.903-.833.903-.46 0-.833-.405-.833-.902.006-.275.353-1.061.833-1.937Zm-.833 4.477V10h1.666V8.03C10.301 7.655 11 6.662 11 5.487c0-1.153-1.27-3.266-1.814-4.122-.311-.488-1.061-.488-1.372 0C7.268 2.222 6 4.335 6 5.488c0 1.175.698 2.168 1.667 2.541Z'
		/>
	</SvgIcon>
);

export const RenewalIcon: React.FC<IIconProps> = ({ fillColor = '#0D0F11' }) => (
	<SvgIcon width='18' height='21' fill='none'>
		<path
			fill={fillColor}
			d='M5.614 5.356c.56.524.636 1.45.136 2.073-.473.586-1.376.655-1.92.144-.46-.43-.965-1.825-1.328-3.15 1.424.254 2.778.62 3.112.933ZM4.72 10c.951 0 1.853-.443 2.476-1.217a3.684 3.684 0 0 0 .795-2.566 3.623 3.623 0 0 0-1.12-2.422C5.601 2.607 1.54 2.185 0 2c.207 1.033 1.003 5.664 2.573 7.135.597.557 1.36.865 2.148.865Z'
		/>
		<path
			fill={fillColor}
			d='M11.41 4.073c.576-.591 2.398-1.169 4.043-1.54-.404 1.857-.96 3.68-1.391 4.123a1.847 1.847 0 0 1-2.616.035 1.856 1.856 0 0 1-.035-2.618Zm1.149 14.87H5.822l-1.37-4.113h9.476l-1.369 4.113ZM10.543 8.591c.643.44 1.4.682 2.193.682 1.063 0 2.056-.42 2.798-1.183C16.929 6.658 17.693 1.821 18 0c-1.027.161-6.316.844-8.061 2.638a3.91 3.91 0 0 0-.78 4.288c-.63.902-.996 1.9-.996 2.835v3.012H3.027a1.027 1.027 0 0 0-.974 1.354l2.054 6.17c.14.42.532.703.974.703H13.3c.442 0 .835-.283.974-.702l2.055-6.17a1.028 1.028 0 0 0-.975-1.355h-5.136V9.761c0-.363.122-.767.326-1.17Z'
		/>
	</SvgIcon>
);

export const AutomationIcon: React.FC<IIconProps> = ({ fillColor = '#0D0F11' }) => (
	<SvgIcon width='21' height='29' fill='none'>
		<path
			fill={fillColor}
			d='M18.498 27H14.5v-3h3.998v3ZM6.5 27h-4v-3h4v3Zm2-16h4v3h-4v-3Zm10.998 11h-2v-1c0-1.654-1.345-3-2.998-3h-3v-2h2a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h2v2h-3c-1.654 0-3 1.346-3 3v1h-2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1h-2v-1c0-.551.449-1 1-1h8a1 1 0 0 1 .998 1v1H13.5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5.998a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1Z'
		/>
		<path fill={fillColor} d='M13.167 6.667h-4V0L2.5 9.333h4V16l6.667-9.333Z' />
	</SvgIcon>
);

export const NewClientIcon: React.FC<IIconProps> = ({ fillColor }) => (
	<AssigneeIcon
		className={css(styleSheet.newClientIcon)}
		strokeWidth='1.5'
		style={fillColor ? { color: fillColor } : undefined}
	/>
);

export const NewLeadIcon: React.FC<IIconProps> = ({ fillColor = '#0D0F11' }) => (
	<SvgIcon width='12' height='23' fill='none'>
		<path
			d='M7.21484 0.230469V3.6875H5.38672V0.230469H7.21484ZM6.99219 19.3672V22.5195H5.16406V19.3672H6.99219ZM8.28125 15.5234C8.28125 15.0781 8.19922 14.6992 8.03516 14.3867C7.87891 14.0742 7.62109 13.7969 7.26172 13.5547C6.91016 13.3125 6.43359 13.0781 5.83203 12.8516C4.81641 12.4609 3.92188 12.0469 3.14844 11.6094C2.38281 11.1641 1.78516 10.6133 1.35547 9.95703C0.925781 9.29297 0.710938 8.45312 0.710938 7.4375C0.710938 6.46875 0.941406 5.62891 1.40234 4.91797C1.86328 4.20703 2.5 3.66016 3.3125 3.27734C4.13281 2.88672 5.08594 2.69141 6.17188 2.69141C7 2.69141 7.75 2.81641 8.42188 3.06641C9.09375 3.30859 9.67188 3.66797 10.1562 4.14453C10.6406 4.61328 11.0117 5.1875 11.2695 5.86719C11.5273 6.54688 11.6562 7.32422 11.6562 8.19922H8.29297C8.29297 7.73047 8.24219 7.31641 8.14062 6.95703C8.03906 6.59766 7.89062 6.29688 7.69531 6.05469C7.50781 5.8125 7.28125 5.63281 7.01562 5.51562C6.75 5.39062 6.45703 5.32812 6.13672 5.32812C5.66016 5.32812 5.26953 5.42188 4.96484 5.60938C4.66016 5.79688 4.4375 6.05078 4.29688 6.37109C4.16406 6.68359 4.09766 7.04297 4.09766 7.44922C4.09766 7.84766 4.16797 8.19531 4.30859 8.49219C4.45703 8.78906 4.71094 9.0625 5.07031 9.3125C5.42969 9.55469 5.92188 9.80469 6.54688 10.0625C7.5625 10.4531 8.45312 10.875 9.21875 11.3281C9.98438 11.7812 10.582 12.3359 11.0117 12.9922C11.4414 13.6484 11.6562 14.4844 11.6562 15.5C11.6562 16.5078 11.4219 17.3672 10.9531 18.0781C10.4844 18.7812 9.82812 19.3203 8.98438 19.6953C8.14062 20.0625 7.16406 20.2461 6.05469 20.2461C5.33594 20.2461 4.62109 20.1523 3.91016 19.9648C3.19922 19.7695 2.55469 19.457 1.97656 19.0273C1.39844 18.5977 0.9375 18.0273 0.59375 17.3164C0.25 16.5977 0.078125 15.7148 0.078125 14.668H3.45312C3.45312 15.2383 3.52734 15.7148 3.67578 16.0977C3.82422 16.4727 4.01953 16.7734 4.26172 17C4.51172 17.2188 4.79297 17.375 5.10547 17.4688C5.41797 17.5625 5.73438 17.6094 6.05469 17.6094C6.55469 17.6094 6.96484 17.5195 7.28516 17.3398C7.61328 17.1602 7.85938 16.9141 8.02344 16.6016C8.19531 16.2812 8.28125 15.9219 8.28125 15.5234Z'
			fill={fillColor}
		/>
	</SvgIcon>
);

export const CommercialIcon: React.FC<IIconProps> = ({ fillColor = '#0D0F11' }) => (
	<SvgIcon width='21' height='20' fill='none'>
		<path fillRule='evenodd' clipRule='evenodd' d='M1 20H20V18H1V20Z' fill={fillColor} />
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M4.45561 5.99999L10.4996 2.18299L16.5436 5.99999H4.45561ZM20.5336 6.15399L11.0336 0.153994C10.7076 -0.0510059 10.2916 -0.0510059 9.96561 0.153994L0.465609 6.15399C0.0896092 6.39199 -0.0843908 6.84999 0.0396092 7.27799C0.162609 7.70599 0.554609 7.99999 0.999609 7.99999H19.9996C20.4446 7.99999 20.8366 7.70599 20.9606 7.27799C21.0846 6.84999 20.9106 6.39199 20.5336 6.15399V6.15399Z'
			fill={fillColor}
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M4 11H5V15H4V11ZM6 17C6.553 17 7 16.553 7 16V10C7 9.448 6.553 9 6 9H3C2.448 9 2 9.448 2 10V16C2 16.553 2.448 17 3 17H6Z'
			fill={fillColor}
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M10 11H11V15H10V11ZM12 17C12.553 17 13 16.553 13 16V10C13 9.448 12.553 9 12 9H9C8.448 9 8 9.448 8 10V16C8 16.553 8.448 17 9 17H12Z'
			fill={fillColor}
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M16 11H17V15H16V11ZM18 17C18.553 17 19 16.553 19 16V10C19 9.448 18.553 9 18 9H15C14.448 9 14 9.448 14 10V16C14 16.553 14.448 17 15 17H18Z'
			fill={fillColor}
		/>
	</SvgIcon>
);

export const CalendarIcon: React.FC<IIconProps> = ({ fillColor = '#0D0F11' }) => (
	<SvgIcon width='21' height='22' fill='none'>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M19.9977 20H2V8H20L19.9977 20ZM19.8 3.3H18.7V0H16.5V5.5H15.4V3.3H7.7V0H5.5V5.5H4.4V3.3H2.2C0.9867 3.3 0 4.2878 0 5.5V19.8C0 21.0133 0.9867 22 2.2 22H19.8C21.0133 22 22 21.0133 22 19.8V5.5C22 4.2878 21.0133 3.3 19.8 3.3V3.3Z'
			fill={fillColor}
		/>
	</SvgIcon>
);
